import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { SpecCourseLessonViewSectionTitle } from 'common.components/spec-course-lesson-view/__section-title/spec-course-lesson-view__section-title';
import { getCurrentTeamLetter, getCurrentTeamLevel } from 'common.components/user/selectors';

export const SpecCourseResultsTitle = () => {
    const { classId } = useParams<{ classId: string }>();

    const teamLevel = useSelector((store) => getCurrentTeamLevel(store, { classId }));
    const teamLetter = useSelector((store) => getCurrentTeamLetter(store, { classId }));

    return (
        <SpecCourseLessonViewSectionTitle
            id="specCourse.lessonView.resultsTable.header"
            values={{ level: teamLevel, name: teamLetter }}
        />
    );
};
